import "./schedules.scss";
import Banner from "../../components/banner/Banner";
import SchedTable from "../../components/schedules/schedTable";
import SchedForm from "../../components/schedules/schedForm";
import { useState } from "react";
// import RequestGeo from "../../components/requestGeo/RequestGeo";
const SchedulesPage = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <div className="schedules">
      <Banner title="Schedules"/>
      <div className="scheduleForm">
        <button onClick={() => setShowForm(!showForm)} className="schedules__header__button">
          {showForm ? "Hide Form" : "Create new schedule"}  
        </button>
      </div>
      {showForm && <SchedForm />}
      <SchedTable />
    </div>
  );
};

export default SchedulesPage;
